import React from 'react'

/**
 * Basic detail page layout:
 * - main content column and right rail column on desktop
 * - one column on mobile
 * @param {Object} props - The props
 * @param {JSX.Element} props.content - The content element
 * @param {JSX.Element} props.rightRail - The rightRail element
 * @returns {JSX.Element} DetailPageV3DefaultLayout
 */

const DetailPageV3DefaultLayout = (props) => {
  const {
    content = null,
    rightRail = null,
  } = props

  return (
    <div className="detail-page-v3__content">
      <div className="detail-page-v3__layout-wrapper">
        <div className="detail-page-v3__columns-layout">
          <div className="detail-page-v3__column detail-page-v3__column--content">
            {content}
          </div>
          <div className="detail-page-v3__column detail-page-v3__column--right-rail">
            {rightRail}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DetailPageV3DefaultLayout
